module.controller('userDetailUpdateCtrl', [ '$scope', '$rootScope', '$state', 'userService', 'alertService', 'roleService', 'parameterService', userDetailUpdateCtrlFn ]);
function userDetailUpdateCtrlFn($scope, $rootScope, $state, userService, alertService, roleService, parameterService) {

	$scope.operationType = $state.current.data.type;
	$scope.idUser = null;
	$scope.user = {
		visible : true,
		client : {}
	};
	$scope.loading = false;

	var planSamplings = [];

	/**
	 * 
	 * @param idUser
	 */
	$scope.load = function(idUser) {
		$scope.loading = true;

		userService.loadUser(idUser).then(function(response) {
			$scope.loading = false;

			var responseData = response.getData();
			$scope.idUser = responseData.id;

			$scope.user = {
				visible : responseData.visible,
				username : responseData.username,
				firstName : responseData.firstName,
				lastName : responseData.lastName,
				email : responseData.email,
				roles : {
					selected : responseData.roles
				},
				client : {},
				planSamplings : {
					selected : responseData.planSamplings
				}
			};

			planSamplings = responseData.planSamplings;

			if (responseData.client != null) {
				$scope.user.client.selected = [ responseData.client ];
			}

		}, function(response) {
			$scope.loading = false;
		});
	};

	$scope.hasRolClient = function() {
		if (angular.isUndefined($scope.user.roles))
			return false;
		var roles = $scope.user.roles.selected;
		for (var i = 0; i < roles.length; i++) {
			if (roles[i].id == ROLE_TYPE.CLIENT.id) {
				return true;
			}
		}

		return false;
	};

	/**
	 * 
	 */
	$scope.onClientChange = function() {
		if ($scope.user.client.selected.length <= 0) {
			$scope.user.planSamplings.selected = [];
		}
	};

	$scope.sendAction = function() {
		$scope.update();
	};

	$scope.sendRoles = function() {
		console.log("actualiza roles");
		alertService.showSwtQuestion('Actualizar roles', updateRoles);

	}

	function updateRoles() {
		var updateModel = {
			roles : []
		}

		$scope.user.roles.selected.forEach(function(r) {
			updateModel.roles.push(r.id);
		});
		console.log(updateModel.roles)

		userService.updateRoles($scope.idUser, updateModel).then(function(response) {
			$scope.loading = false;
			$state.go('home.userList');
			alertService.showSuccess('Roles actualizados satisfactoriamente');
		}, function(response) {
			$scope.loading = false;
		});
	}

	/**
	 * 
	 */
	$scope.update = function() {
		alertService.showSwtQuestion('Actualizar Usuario', function() {
			$scope.loading = true;

			var updateModel = {
				idClient : null,
				firstName : $scope.user.firstName,
				lastName : $scope.user.lastName,
				email : $scope.user.email
			};

			if (angular.isDefined($scope.user.client) && angular.isDefined($scope.user.client.selected)) {
				if ($scope.user.client.selected[0] != undefined) {
					updateModel.idClient = $scope.user.client.selected[0].id;
					updateModel.psamplings = [];
					var planAdd = $scope.user.planSamplings.selected
					
					if (planAdd.length > 0) {
						updateModel.psamplings = planAdd.map(mapPlan);
					}

				}
			}

			userService.updateUser($scope.idUser, updateModel).then(function(response) {
				$scope.loading = false;
				$state.go('home.userList');
				alertService.showSuccess('Usuario actualizado satisfactoriamente');
			}, function(response) {
				$scope.loading = false;
			});
		});
	};

	function notExistPlan(p) {
		return !this.some(function(ps) {
			return ps.id == p.id
		});
	}
	
	function mapPlan(currentValue) {
		return currentValue.id;
	}
	

	$scope.load($state.params.id);

}
